import { Injectable } from "@angular/core";
import { Topics } from "@common/interfaces/topics";
import { IID_OL_SOSPENSIONE } from "@common/interfaces/interfaceData";
import { ID } from '@common/interfaces/id';
import { EntityState, EntityStore, StoreConfig } from "@datorama/akita";

export interface IIdOlSospensioneState extends EntityState<IID_OL_SOSPENSIONE, ID> { }

@Injectable({
  providedIn: 'root'
})
@StoreConfig({ name: Topics.IID_OL_SOSPENSIONE })
export class IIDolSospensioneStore extends EntityStore<IIdOlSospensioneState> {
  constructor() {
    super([]);
  }
}
